import { createApi } from '@reduxjs/toolkit/query/react';
import { delegatingBaseQuery } from './base-query-registry.js';

export const apiTagTypes = [
  'Agent',
  'Anamnesis',
  'AppVersion',
  'Article',
  'Category',
  'Changelog',
  'Device',
  'Evaluation',
  'EvaluationSession',
  'Feedback',
  'Group',
  'Institution',
  'InstitutionMember',
  'Module',
  'Notification',
  'Patient',
  'Practitioner',
  'Profile',
  'Question',
  'Recommendation',
  'Scale',
  'Subscription',
  'Training',
  'Video',
  'AdminUser',
  'AdminInstitution',
] as const;

export type ApiTagType = (typeof apiTagTypes)[number];

/**
 * Single RTK Query api slice shared by web and mobile. Domain endpoints are added elsewhere via
 * `baseApi.injectEndpoints(...)` (see `api/endpoints/`) so this module stays a stable
 * registration point. `baseQuery` is `delegatingBaseQuery`, which forwards to whichever
 * `edenBaseQuery` the consuming app registered via `setBaseQueryImpl` — `packages/shared` has no
 * HTTP client of its own (no fetch, no Eden Treaty `App` type import: that would create a
 * server <-> shared build cycle).
 *
 * Built with `@reduxjs/toolkit/query/react` so injected endpoints get auto-generated hooks
 * (`useGetChangelogEntriesQuery`, ...) typed for both apps directly from this one definition.
 * This is the one part of `packages/shared` that depends on React (via `react-redux`) — it is
 * intentionally NOT re-exported from the package root (`src/index.ts`); import it from the
 * `@metadevprofile/shared/api` subpath instead, so `apps/server` (which imports the package root
 * at runtime) never evaluates this module.
 */
export const baseApi = createApi({
  reducerPath: 'api',
  baseQuery: delegatingBaseQuery,
  tagTypes: apiTagTypes,
  endpoints: () => ({}),
});
